import { Component, Input, Inject, OnInit, ChangeDetectorRef } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { Evaluation } from '../../../models/evaluation/evaluation.model';
import { NoteService } from '../../../services/note.service';
import { Note } from '../../../models/evaluation/note.model';
import { AlertService, DialogType, MessageSeverity } from '../../../services/alert.service';
import { Utilities } from '../../../services/utilities';
import { ArraySortPipe } from '../../../pipes/sort.pipe';
import { CommonModule, DatePipe, TitleCasePipe } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'app-abstract-bottom-sheet',
  templateUrl: './abstract-bottom-sheet.component.html',
  styleUrls: ['./abstract-bottom-sheet.component.css'],
  imports: [
    CommonModule,
    DatePipe,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    TitleCasePipe
  ]
})
export class AbstractBottomSheetComponent implements OnInit {

  note: Note = new Note();
  userName = '';

  constructor(private bottomSheetRef: MatBottomSheetRef<AbstractBottomSheetComponent>,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
    private noteService: NoteService,
    private alertService: AlertService,
    private changeDetectorRef: ChangeDetectorRef) {
  }

  public ngOnInit(): void {
  }

  saveNote() {


    if (this.note.notePlain != null && this.note.notePlain.trim() != '') {
      this.note.abstractProtocolID = this.data.abstractProtocolId;
      this.note.evaluationID = this.data.evaluationId;

      this.noteService.addNote(this.note)
        .subscribe({
          next: note => {
          this.data.notes.push(note);
          this.note.notePlain = '';

          this.changeDetectorRef.markForCheck();

          this.alertService.showMessage("Note", `Saved!`, MessageSeverity.success);

        },
          error: (error) => {
            this.alertService.showStickyMessage("Save Error", `Unable to save the note.\r\nIf error persist, please contact IT.\r\nErrors: "${Utilities.getHttpResponseMessage(error)}"`,
              MessageSeverity.error, error);
          }});;
    }


  }

  openLink(event: MouseEvent): void {
    this.bottomSheetRef.dismiss();
    event.preventDefault();
  }
}
